<div *ngIf="showScreenType == 'list'" class="container">
  <div class="search-text-container">
    <dx-text-box
      id="float-input"
      [(value)]="searchLegalEntity"
      appCustomAutofocus
      [style]="{ width: '100%' }"
      (onInput)="searchEntity($event)"
      placeholder="Type your search text here..."
      >
    </dx-text-box>
  </div>

  <div class="search-button">
    <dx-button class="le-search-btn"
      *appCheckPermission="null; permissions: ['legalentity.create']; requireLegalEntityContext: false"
      [style]="{ width: '100%' }"
      text="Add a legal entity"
                    stylingMode="contained"
                    type="default" style="background-color: orange;"
                    icon="" (onClick)="addLegalEntity()">
                </dx-button>
  </div>

  <div *ngIf="filteredEntities && filteredEntities.length>0" class="list-container">
    <dx-list
        [dataSource]="filteredEntities"
        selectionMode="single"
        displayExpr="legalEntityName"
        (onItemClick)="selectedLegalEntity($event)">
        <div *dxTemplate="let item of 'item'">
          <div class="le-item">
            <div class="le-name">
              <i class="dx-icon-user dx-avatar" style="font-size: x-large;"></i>
              <span>{{ item.legalEntityName }}</span>
            </div>
            <div class="le-secondary">{{ item.legalEntityType }}</div>
          </div>
        </div>
    </dx-list>
  </div>
</div>

<div *ngIf="showScreenType == 'add'" class="add-screen-host">
  <app-create-legal-entity (closeLegalEntityPopupEvent)="hideAddLegalEntitiesPopup()" (messageEvent)="onCreateEntityMessage($event)"></app-create-legal-entity>
</div>

<div *ngIf="showScreenType == 'message'">
  <div class="message-container">
    <span class="message-header">Success</span>
    <span class="message-text">{{ messageText }}</span>
    <div class="message-actions">
      <dx-button text="Close" stylingMode="outlined" type="default" (onClick)="closePopup()"></dx-button>
      <dx-button text="View Legal Entity" stylingMode="contained" type="default" (onClick)="goToLegalEntityOverview()"></dx-button>
    </div>
  </div>
</div>